module.exports = __webpack_public_path__ + "img/photoshop.e15ada62.png";